import { StateKey } from 'common/utils/flipState'
import {
  fetchAdditionalInfoFromPay,
  fetchMyDetails,
  fetchPagedMyReviews as fetchServerPagedMyReviews,
} from 'common/services/review'
import {
  AdditionalPayInfo,
  PagedReviews,
  Review,
  ReviewPagingParams,
  StatusType,
} from 'common/types/entities/api/review'
import { REVIEW_LIST_PAGE_SIZE } from 'common/constants/review'
import { ArrayUtils } from '@shopping/common'

const FETCH = 'review/pagedMyReview/FETCH'
const APPEND = 'review/pagedMyReview/APPEND'
const REMOVE = 'review/pagedMyReview/REMOVE'
const MODIFY = 'review/pagedMyReview/MODIFY'
const FETCH_PREV_REVIEW = 'review/pagedMyReview/FETCH_PREV_REVIEW'

const initialState: PagedReviews = {
  contents: [],
  page: 0,
  size: 0,
  totalElements: 0,
  totalPages: 0,
}
export const fetchPagedMyReviews = (
  params: ReviewPagingParams,
  curState: StateKey,
  headers: any,
  isAppend?: boolean,
) => async dispatch => {
  const pagedReviews = await fetchServerPagedMyReviews(params, headers)
  if (pagedReviews && pagedReviews.totalElements > 0) {
    const productOrderNos: string[] = pagedReviews.contents.map(content => content.productOrderNo)
    const additionalPayInfo: AdditionalPayInfo = await fetchAdditionalInfoFromPay(
      productOrderNos.join(','),
      'WRITTEN_REVIEW',
    )
    additionalPayInfo &&
      pagedReviews.contents.forEach(content => {
        Object.assign(content, additionalPayInfo.productOrders[content.productOrderNo])
        Object.assign(content, additionalPayInfo.reviews[content.productOrderNo])
        content.purchaseDecisionYmdt = new Date(content.purchaseDecisionYmdt).setHours(0, 0, 0, 0)
        content.createDate = new Date(content.createDate).setHours(0, 0, 0, 0)
        if (content.benefitPaymentDate) {
          content.benefitPaymentDate = new Date(content.benefitPaymentDate).setHours(0, 0, 0, 0)
        }
      })
  }
  dispatch({
    curState,
    pagedReviews,
    page: params.page,
    type: isAppend ? APPEND : FETCH,
  })
}

export const fetchPrevReview = (curState: StateKey, parentReviewSeq: number, reviewId: number) => async (
  dispatch,
  getState,
) => {
  const prevReviews = await fetchMyDetails([parentReviewSeq])
  if (ArrayUtils.isNotEmpty(prevReviews)) {
    const appendedPrevReviews: Review[] = getState().pagedMyReview[curState].contents.map(content => {
      let appendedPrevReview = content
      if (appendedPrevReview.id === reviewId) {
        appendedPrevReview = { ...content }
        appendedPrevReview.prevReview = prevReviews[0]
      }
      return appendedPrevReview
    })
    dispatch({
      curState,
      appendedPrevReviews,
      type: FETCH_PREV_REVIEW,
    })
  }
}
export const removeMyReview = (curState: StateKey, reviewId: number) => async dispatch => {
  dispatch({
    curState,
    reviewId,
    type: REMOVE,
  })
}

export const modifyMyReview = (curState: StateKey, modifiedReviewParam: Review, isPrevReview?: boolean) => async (
  dispatch,
  getState,
) => {
  const reviewListWithModified: Review[] = getState().pagedMyReview[curState].contents
  const modifiedIndex = reviewListWithModified.findIndex(content => content.id === Number(modifiedReviewParam.id))
  let parentReviewModifiedId = -1
  const prevReviewModified = modifiedIndex < 0 || isPrevReview
  if (prevReviewModified) {
    parentReviewModifiedId = reviewListWithModified.findIndex(
      content => content.prevReview && content.prevReview.id === Number(modifiedReviewParam.id),
    )
  }

  let modifiedReview: Review = {
    ...reviewListWithModified[prevReviewModified ? parentReviewModifiedId : modifiedIndex],
  }
  if (prevReviewModified) {
    modifiedReview.prevReview = {
      ...modifiedReview.prevReview,
      reviewScore: modifiedReviewParam.reviewScore,
      reviewContent: modifiedReviewParam.reviewContent,
      reviewAttaches: modifiedReviewParam.reviewAttaches,
      modified: true,
    }
  } else {
    modifiedReview = {
      ...modifiedReview,
      reviewScore: modifiedReviewParam.reviewScore,
      reviewContent: modifiedReviewParam.reviewContent,
      reviewAttaches: modifiedReviewParam.reviewAttaches,
      modified: true,
    }
  }

  reviewListWithModified[!prevReviewModified ? modifiedIndex : parentReviewModifiedId] = modifiedReview
  dispatch({
    curState,
    reviewListWithModified,
    type: MODIFY,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return action.pagedReviews
    case APPEND:
      return {
        ...state,
        contents: [...state.contents, ...action.pagedReviews.contents],
        page: action.page,
      }
    case REMOVE:
      const removedReviewContents: Review[] = state.contents.filter(content => content.id !== action.reviewId)
      const removedPrevReview = removedReviewContents.map(content => {
        if (content.prevReview && content.prevReview.id === action.reviewId) {
          content.prevReview.reviewContent = '삭제된 리뷰입니다.'
          content.prevReview.reviewDisplayStatusType = StatusType.REMOVE
        }
        return content
      })
      return {
        ...state,
        contents: removedPrevReview,
        totalElements: state.totalElements - 1,
        totalPages: Math.ceil((state.totalElements - 1) / REVIEW_LIST_PAGE_SIZE),
      }
    case MODIFY:
      return {
        ...state,
        contents: action.reviewListWithModified,
      }
    case FETCH_PREV_REVIEW:
      return {
        ...state,
        contents: action.appendedPrevReviews,
      }
    default:
      return state
  }
}
export default reducer
